export function downloadViaNavigation(path: string, target: '_blank' | '_self' = '_blank') {
  // Normalize incoming path
  const p = path.startsWith('/') ? path : `/${path}`

  const backendBase = process.env.NEXT_PUBLIC_BACKEND_URL

  const absolute = backendBase ? new URL(p, backendBase).toString() : p

  window.open(absolute, target, 'noopener,noreferrer')
}
